<template>
  <div class="bank-box">
    <div class="bb-info">
      <span>{{detail.userName}}</span>
      <span>{{ detail.type }}</span>
    </div>
    <div class="bb-code">
      {{ detail.bankCode }}
    </div>
  </div>
</template>

<script>
export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  name: "bank-box",
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.bank-box{
  .bb-info{
    color: #9e9e9e;
    height: 25px;
    line-height: 25px;
    span{
      margin-right: 10px;
    }
  }
  .bb-code{
    color: #9e9e9e;
    height: 25px;
    line-height: 25px;
  }
}
</style>
